<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap class="justify-center">
        <v-flex xs12 sm11 md10>
          <h3 class="text-center">Registration Bodies</h3>
          <v-card flat>
            <v-card-title class="py-1">
              <v-spacer></v-spacer>
              <v-btn text outlined title="Add new body" @click="create = !create">
                <v-icon left>fa-plus</v-icon>Add
              </v-btn>
            </v-card-title>
            <v-card-text>
              <v-data-table :items="bodies" :headers="headers">
                <template v-slot:[`item.actions`]="{ item }">
                  <td>
                    <v-btn small icon :title="'Edit ' + item.name" @click="editBody(item)" color="orange">
                      <v-icon>{{ icons.edit }}</v-icon>
                    </v-btn>
                    <v-btn small icon :title="'Delete ' + item.name" @click="deleteBody(item)" color="red">
                      <v-icon>{{ icons.delete }}</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="create" @close="create = false">
        <template slot="title">Add Registration Body</template>
        <add-reg-body @saved="create = false" v-if="create"></add-reg-body>
      </modal-dialog>
      <modal-dialog :open="editting" @close="editting = false">
        <template slot="title">Edit Registration Body</template>
        <edit-reg-body :edit="edit" @saved="editting = false; edit = {}" v-if="editting"></edit-reg-body>
      </modal-dialog>
    </v-container>
  </transition>
</template>

<script>
  import layout from '@/Layouts/MainLayout'
  const AddRegBody = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "reg-bodies" */ '@/Components/RegBodies/create')
  const EditRegBody = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "reg-bodies" */ '@/Components/RegBodies/edit')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')

  export default {
    name: 'RegistrationBodies',
    props: [
      'bodies'
    ],
    components: {
      AddRegBody,
      ModalDialog,
      EditRegBody,
    },
    metaInfo () {
      return {
        title: 'Registration Bodies',
        titleTemplate: '%s | ' + this.$title,
      }
    },
    layout,
    data () {
      return {
        create: false,
        headers: [
          {
            text: 'Name', value: 'name'
          },
          {
            text: 'Email', value: 'email',
          },
          {
            text: 'Phone', value: 'phone'
          },
          {
            text: 'Created By', value: 'user.name'
          },
          {
            text: 'Actions', value: 'actions', align: 'right', sortable: false
          }
        ],
        editting: false,
        edit: {}
      }
    },
    methods: {
      deleteBody (body) {
        if (confirm(body.name + '. Are you sure you want to delete this record?')) {
          this.$inertia.delete('registration_bodies/' + body.id)
        }
      },
      editBody (body) {
        this.edit = body;
        this.editting = true
      }
    },
  }
</script>
